module.exports = __webpack_public_path__ + "static/media/AP_Moderate_Z2.31393f26.png";